import React, { useEffect, useState } from "react";
import styles from "./beneficiary.module.css";
import BeneficiaryModal from "./BeneficiaryModal";
import {
  FormControl,
  InputLabel,
  Select,
  TablePagination,
} from "@mui/material";
import { useAllProduct } from "../../api-context/commonApiContext";
import config from "../../service/config";
import { Spin } from "antd";
import FullScreenLoader from "../../reusable/loader/FullScreenLoader";
import Lottie from "lottie-react";
import approved from "../../reusable/Animation/Animation-SuccessfulGIF.json";
import { useNavigate } from "react-router-dom";

const Beneficiary = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const {
    loggedBy,
    collectsEnabled,
    payoutsEnabled,
    setLoading,
    loading,
    userId,
    clientId,
    selectedCompanyName,
  } = useAllProduct();
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [showModal, setShowModal] = useState(false);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [deleteDeneficiaries, setDeleteBeneficiaries] = useState(false);
  const [selectedRowVal, setSelectedRowVal] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [beneficiaryAdded, setBeneficiaryAdded] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBeneficiaries = async () => {
      try {
        setLoading(true);

        const res = await fetch(
          `${config.node_api_endpoint}/api/beneficiaries?createdByUserId=${userId}&clientId=${clientId}&selectedCompanyName=${selectedCompanyName}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
          }
        );

        const result = await res.json();
        console.log("result", result);

        if (result.success) {
          setRefreshData(false);
          const flatList = result.data.flatMap((block) => {
            const companyBlock = block[selectedCompanyName.trim()];
            return companyBlock?.entries || [];
          });
          setBeneficiaries(flatList.sort((a, b) => b.id - a.id));
        } else {
          console.error("Error fetching beneficiaries:", result.message);
        }
      } catch (error) {
        console.error("API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBeneficiaries();
  }, [refreshData, selectedCompanyName]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0); // Reset to first page
  };

  const filteredBeneficiaries = beneficiaries.filter((b) =>
    [b.name, b.nickname, b.account_or_upi, b.ifsc, b.account_type]
      .join(" ")
      .toLowerCase()
      .includes(searchQuery)
  );

  const paginatedReports = filteredBeneficiaries.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const deleteBeneficiary = async (id) => {
    try {
      const res = await fetch(
        `${config.node_api_endpoint}/api/beneficiaries/${id}?clientId=${clientId}&selectedCompanyName=${selectedCompanyName}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
        }
      );

      const result = await res.json();

      if (result.success) {
        alert("Beneficiary deleted successfully.");
        setRefreshData(true);
      } else {
        alert(result.message || "Failed to delete beneficiary.");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      alert("Something went wrong while deleting.");
    }
  };

  return (
    <>
      <FullScreenLoader spinning={loading} />
      {beneficiaryAdded && (
        <div className={styles.modalBackdrop}>
          <div className={styles.modalContainer}>
            <div className={`d-flex justify-content-center`}>
              <Lottie
                className={styles.httpslottiefilescomanimatIcon}
                animationData={approved}
                loop
              />
            </div>
            <div className={styles.successMessage}>{successMsg}</div>
            <div className="d-flex justify-content-center gap-3 mt-3">
              <button
                className={`${styles.transactionsButtons} ${styles.activeButton}`}
                onClick={() => {
                  setBeneficiaryAdded(false); // hide modal first
                }}
              >
                <div className={styles.transactions}>
                  Return to Beneficiary List
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="d-flex justify-content-between">
        <div className={`${styles.title} mt-5`}>Beneficiary</div>
        <button
          type="button"
          className={`${styles.bulkPayoutButton} mt-5 d-flex justify-content-center align-items-center p-2 gap-2`}
          onClick={() => {
            setSelectedRowVal({});
            setShowModal(true);
          }}
          disabled={
            (loggedBy === "bank_admin" || loggedBy === "user") &&
            collectsEnabled === true &&
            payoutsEnabled === false
              ? false
              : (loggedBy === "bank_admin" || loggedBy === "user") &&
                collectsEnabled === false &&
                payoutsEnabled === true
              ? false
              : (loggedBy === "bank_admin" || loggedBy === "user") &&
                collectsEnabled === true &&
                payoutsEnabled === true
              ? false
              : (loggedBy === "bank_admin" || loggedBy === "user") &&
                collectsEnabled === false &&
                payoutsEnabled === false
              ? true
              : loggedBy === "client" &&
                collectsEnabled === true &&
                payoutsEnabled === false
              ? false
              : loggedBy === "client" &&
                collectsEnabled === false &&
                payoutsEnabled === true
              ? false
              : loggedBy === "client" &&
                collectsEnabled === true &&
                payoutsEnabled === true
              ? true
              : loggedBy === "client" &&
                collectsEnabled === false &&
                payoutsEnabled === false
              ? false
              : ""
          }
        >
          <img
            className={`${styles.plusCircleIcon} pe-1`}
            alt=""
            src="/pluscircle.svg"
          />
          Create Beneficiary
        </button>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>
                Beneficiary List
              </h3>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.filterLabel}
                      placeholder="Search..."
                      type="text"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value.toLowerCase());
                        setCurrentPage(0); // Reset pagination on search
                      }}
                    />
                  </div>
                </div>
                {/* <ButtonWithIcon icon="filterlines.svg" text="Filter" /> */}
                <div
                  className={styles.reLoadTable}
                  onClick={() => {
                    console.log("helloo World");
                    setRefreshData(true);
                  }}
                >
                  <img
                    className={styles.reloadIcon}
                    loading="lazy"
                    alt=""
                    src="/reload.svg"
                  />
                </div>
              </div>
            </div>
            <div className={styles.headerSeparator} />
          </div>

          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}>BENEFICIARY NAME</div>
              <div className={styles.cell}>BENEFICIARY TYPE</div>
              <div className={styles.cell}>NICKNAME</div>
              <div className={styles.cell}>BANK A/C - UPI ID </div>
              <div className={styles.cell}>IFSC CODE </div>
              <div className={styles.cell}>STATUS</div>
              <div className={styles.cell}>ACTION</div>
            </div>

            {paginatedReports.length === 0 ? (
              <div
                className={`d-flex justify-content-center align-items-center py-4`}
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  height: "30vh",
                }}
              >
                <div className=" w-100">No data available</div>
              </div>
            ) : (
              paginatedReports.map((report, index) => (
                <div className={styles.tableRow} key={index}>
                  <div className={styles.cell}>{report.name}</div>
                  <div className={styles.cell}>{report.account_type}</div>
                  <div className={styles.cell}>{report.nickname}</div>
                  <div className={styles.cell}>
                    {report.upi_id?.length > 0
                      ? report.upi_id
                      : report.account_number}
                  </div>
                  <div className={styles.cell}>{report.ifsc || "---"}</div>
                  <div className={styles.cell}>
                    <span
                      className={`${
                        report.status === "Draft"
                          ? styles.statusDraft
                          : report.status === "Verification pending"
                          ? styles.statusPending
                          : report.status === "Verified"
                          ? styles.statusVerified
                          : styles.statusFailed
                      } px-3 pt-1 pb-1`}
                    >
                      {report.status}
                    </span>
                  </div>
                  <div className={styles.cell}>
                    <span
                      className={styles.actionButton}
                      onClick={() => {
                        setSelectedRowVal(report);
                        setShowModal(true);
                      }}
                    >
                      Edit
                    </span>{" "}
                    <span className="px-2" style={{ color: "#3246A9" }}>
                      /
                    </span>{" "}
                    <span
                      className={styles.actionButton}
                      // onClick={() => deleteBeneficiary(report.id)}
                      onClick={() => {
                        setSelectedRowVal(report);
                        setDeleteBeneficiaries(true);
                      }}
                    >
                      <img src="./delIcon.svg" className={styles.deleteIcon} />
                    </span>
                  </div>
                </div>
              ))
            )}
            <TablePagination
              component="div"
              count={filteredBeneficiaries.length}
              page={currentPage}
              onPageChange={handlePageChange}
              rowsPerPage={itemsPerPage}
              onRowsPerPageChange={handleRowsPerPageChange}
              rowsPerPageOptions={[5, 8, 10, 20]}
              sx={{
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "14px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "14px",
                },
              }}
            />
          </div>
        </section>
      </div>
      {showModal && (
        <BeneficiaryModal
          page={"view"}
          selectedRowVal={selectedRowVal}
          onClose={() => setShowModal(false)}
          setBeneficiaryAdded={setBeneficiaryAdded}
          setSuccessMsg={setSuccessMsg}
          setRefreshData={setRefreshData}
        />
      )}
      {deleteDeneficiaries && (
        <div
          className={`modal show d-block ${styles.rejectionModal}`}
          tabIndex="-1"
          role="dialog"
        >
          <div
            className={`modal-dialog modal-dialog-centered ${styles.modalDialog}`}
            role="document"
          >
            <div className={`modal-content ${styles.modalContent}`}>
              <div className={`modal-header ${styles.modalHeader}`}>
                <h5 className={`modal-title ${styles.modalTitle}`}>
                  Are you sure you want to remove the user?
                </h5>
              </div>

              <div className={`modal-footer ${styles.modalFooter}`}>
                <div
                  className={`${styles.cancelButton} d-flex justify-content-center align-items-center`}
                  onClick={() => setDeleteBeneficiaries(false)}
                >
                  <button
                    type="button"
                    className={`btn`}
                    style={{ color: "#2348AB" }}
                  >
                    No
                  </button>
                </div>
                <div
                  className={`${styles.rejectButton}  d-flex justify-content-center align-items-center`}
                  onClick={() => {
                    deleteBeneficiary(selectedRowVal.id);
                    setDeleteBeneficiaries(false);
                  }}
                >
                  <button
                    type="button"
                    className={`btn`}
                    style={{ color: "#ffffff" }}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Beneficiary;
